// extracted by mini-css-extract-plugin
export default {"nav-list":"Navigation-list_nav-list__Rrhmz","nav-list-start":"Navigation-list_nav-list-start__7Wt6M","nav-list-end":"Navigation-list_nav-list-end__1mSNw"};